import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService, fromSecondsToMilliseconds } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class MessageSnackBarConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getDurationInMillis(): number {
		return this.configService.get((x) => x.matCoreUi.messageSnackBar.duration, fromSecondsToMilliseconds(4));
	}
}
